import { StoryblokComponent, useStoryblok } from "@storyblok/react";
import Preloader from "components/GlobalPreloader/Preloader";
import { useTranslation } from "react-i18next";

const BlogHomePage = () => {
  const { i18n } = useTranslation();
  const story = useStoryblok("home", {
    version: "draft",
    language: i18n.language,
    resolve_relations: ["navigation.items", "featired_articles.articles"],
  });

  if (!story?.content) {
    return (
      <Preloader
        customStyles={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          padding: "0",
          margin: "0",
          border: 0,
          background: "rgba(255, 255, 255, 0.6)",
        }}
      />
    );
  }

  return <StoryblokComponent blok={story.content} />;
};

export default BlogHomePage;
